import { N800 } from '@atlaskit/theme/colors';

export const overrideMarks: string[] = ['backgroundColor'];

export const DEFAULT_COLOR: {
	// TODO: DSP-4137 - Remove usage of N800
	/* eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage */
	color: string;
	label: string;
} = {
	// TODO: DSP-4137 - Remove usage of N800
	/* eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage */
	color: N800.toLowerCase(),
	label: 'Dark gray',
};
